import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'FECHAMENTO_ESTOQUE_DIARIO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'FECHAMENTO_ESTOQUE_DIARIO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('fechamentoEstoqueDiarioForm', registro)
    ];
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/fechamentoEstoqueDiario`);
    return {
        type: 'FECHAMENTO_ESTOQUE_DIARIO_LISTADO',
        payload: request
    };
}

export function getListaProduto() {
    const request = axios.get(`${consts.API_URL}/produto/listarSelect`);
    return {
        type: 'FECHAMENTO_ESTOQUE_DIARIO_PRODUTO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaUnidade() {
    const request = axios.get(`${consts.API_URL}/unidade/listarSelect`);
    return {
        type: 'FECHAMENTO_ESTOQUE_DIARIO_UNIDADE_SELECT_LISTADO',
        payload: request
    };
}
